import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirm-logout-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, CommonModule],
  template: `
    <div class="logout-card">
      <div class="icon-circle">
        <mat-icon>logout</mat-icon>
      </div>

      <div class="logout-content">
        <h2>Confirm Logout</h2>
        <p>Are you sure you want to log out of your session?</p>
      </div>

      <div class="logout-actions">
        <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn-logout" (click)="onConfirm()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .logout-card {
        padding: 24px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background-color: #ffffff;
        border-radius: 16px;
        width: 100%;
        box-sizing: border-box;
      }

      .icon-circle {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        background-color: #fee2e2;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 14px;

        mat-icon {
          font-size: 26px;
          width: 26px;
          height: 26px;
          color: #ef4444;
        }
      }

      .logout-content {
        margin-bottom: 22px;

        h2 {
          font-size: 18px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 6px 0;
          line-height: 1.2;
        }

        p {
          font-size: 13.5px;
          color: #64748b;
          margin: 0;
          line-height: 1.4;
        }
      }

      .logout-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;

        .btn-cancel {
          flex: 1;
          height: 40px;
          border-radius: 8px;
          border: 1px solid #cbd5e1;
          background-color: #f8fafc;
          color: #475569;
          font-size: 13.5px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background-color: #f1f5f9;
            color: #1e293b;
            border-color: #94a3b8;
          }
        }

        .btn-logout {
          flex: 1;
          height: 40px;
          border-radius: 8px;
          border: none;
          background-color: #ef4444;
          color: #ffffff;
          font-size: 13.5px;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
          transition: all 0.2s ease;

          mat-icon {
            font-size: 18px;
            width: 18px;
            height: 18px;
          }

          &:hover {
            background-color: #dc2626;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
          }
        }
      }
    `,
  ],
})
export class ConfirmLogoutDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmLogoutDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
